import {
    Box,
    Typography,
    useMediaQuery,
    useTheme,
    IconButton,
    Grid,
  } from "@mui/material";
  import React, {useState } from "react";
  import Grid2 from "@mui/material/Grid2";
  import YourBookingCard from "./YourBookingCard";
  import PaymentCard from "./PaymentCard";
  import { useDispatch, useSelector } from "react-redux";

  import { AddCircle, RemoveCircle } from "@mui/icons-material";
  import ExpandLessTwoToneIcon from "@mui/icons-material/ExpandLessTwoTone";
  import ExpandMoreTwoToneIcon from "@mui/icons-material/ExpandMoreTwoTone";
  import ShowMoreLessText from "../horecaWidget/ShowMoreLessText";
  import AddressCard from "./AddressCard";
  import CombinationCard from "./CombinationCard";
  import { format_Number } from "../../utils/utils";
import CardSection from "./CardSection";
  
  const UpsaleProduct = ({
    setQuantities,
    setSelectedExtraProduct,
    extraProductData,
    quantities,
    totalCount,
    languageWords,
    reservType,
    selectedDate,
    adult,
    child,
    kid,
    baby,
    toddler,
    selectedExtraProduct,
    time,
    transactionDetails,
    selectedCombination,
    transactionPrice,excludingVat,totalVat,totalIncludingVAT,
    totalCostYourBooking
  }) => {
    const theme = useTheme();
    const [showMore, setShowMore] = useState(false);
    const dispatch = useDispatch();
    const { widgetConfig } = useSelector((store) => store?.widgetSettings);
    const [isShowMore, setIsShowMore] = useState(false);
    const productsToDisplay =
      extraProductData?.length > 0
        ? isShowMore
          ? extraProductData
          : extraProductData?.slice(0, 4)
        : [];
    const [isImageValid, setIsImageValid] = useState(true); // Track image validity
  
    const handleProductSelect = (item) => {
      const isSelected = selectedExtraProduct?.some(
        (product) => product.idproduct === item.idproduct
      );
      const currentQuantity = quantities[item.idproduct] || 0;
      const newQuantity = isSelected ? 0 : currentQuantity + 1;
  
      if (isSelected) {
        dispatch(
          setSelectedExtraProduct(
            selectedExtraProduct.filter(
              (product) => product.idproduct !== item.idproduct
            )
          )
        );
      
      } else {
        dispatch(
          setSelectedExtraProduct([
            ...selectedExtraProduct,
            { ...item, quantity: newQuantity },
          ])
        );
      }
  
      dispatch(setQuantities({ ...quantities, [item.idproduct]: newQuantity }));
    };
  
    const handleQuantityChange = (item, increment) => {
      const currentQuantity = quantities[item.idproduct] || 0;
      const newQuantity = Math.max(currentQuantity + (increment ? 1 : -1), 0); // Prevent negative quantity
  
      dispatch(setQuantities({ ...quantities, [item.idproduct]: newQuantity }));
      // Update selectedExtraProduct
      if (newQuantity === 0) {
        // Remove the item if quantity is zero
        dispatch(
          setSelectedExtraProduct(
            selectedExtraProduct.filter(
              (product) => product.idproduct !== item.idproduct
            )
          )
        );
      } else {
        // Update or add the item with the new quantity
        const updatedSelectedProducts = selectedExtraProduct.map((product) => {
          if (product.idproduct === item.idproduct) {
            return { ...product, quantity: newQuantity }; // Update quantity
          }
          return product; // Return other products unchanged
        });
  
        // If item was not previously selected, add it
        if (
          !updatedSelectedProducts.some(
            (product) => product.idproduct === item.idproduct
          )
        ) {
          updatedSelectedProducts.push({ ...item, quantity: newQuantity });
        }
  
        dispatch(setSelectedExtraProduct(updatedSelectedProducts));
      }
    };
  
    return (
      <Box>
      <Grid2 container spacing={2}>
      <Grid2 size={{ md: 9, sm: 12, xs: 12 }}>
  {productsToDisplay?.map((item, index) => (
    <Box
      key={index}
      sx={{
        border: "1px solid #EBEBEB",
        p: 3,
        borderRadius: "10px",
        backgroundColor: selectedExtraProduct?.some(
          (product) => product.idproduct === item.idproduct
        )
          ? theme?.product?.bgActive
          : theme?.product?.bgColor,
        mb: 2,
        boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 8px",
        width: "100%",
        cursor: "pointer",
        transition: "all 0.3s ease",
        '&:hover': {
          boxShadow: "rgba(0, 0, 0, 0.2) 4px 4px 12px",
        },
      }}
    >
      <Grid container spacing={2} alignItems="center">
        {item?.image && isImageValid && (
          <Grid item xs={12} sm={4} md={2}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
  
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                borderRadius: "8px",
                overflow: "hidden",
              //  boxShadow: "rgba(0, 0, 0, 0.1) 2px 2px 8px",
              }}
            >
              <img
                src={item?.image}
                alt={item?.languages[0]?.data}
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                onLoad={() => setIsImageValid(true)}
                onError={() => setIsImageValid(false)}
              />
            </Box>
          </Grid>
        )}
  
        <Grid item xs={12} sm={8} md={10}>
          <Box sx={{ width: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
              <Typography sx={{ fontSize: { md: "20px", sm: "16px" }, fontWeight: "bold",                   color: selectedExtraProduct?.some(
                        (product) => product.idproduct === item.idproduct
                      )
                        ? theme?.product?.headerActive
                        : theme?.product?.headerColor, }}>
                {item?.languages[0]?.data}
              </Typography>
              <Typography sx={{ fontSize: { md: "18px", sm: "14px" }, fontWeight: "bold",      color: selectedExtraProduct?.some(
                        (product) => product.idproduct === item.idproduct
                      )
                        ? theme?.product?.priceColorActive
                        : theme?.product?.priceColor }}>
                €{format_Number(parseFloat(item?.price).toFixed(2))}
              </Typography>
            </Box>
        
           {item?.languages[1]?.data && <ShowMoreLessText
            text={item?.languages[1]?.data}
            isShowMore={showMore}
            setIsShowMore={() => setShowMore(!showMore)}
            style={
              {
                color: selectedExtraProduct?.some(
                  (product) => product.idproduct === item.idproduct
                )
                  ? theme?.product?.itemTextActive
                  : theme?.product?.itemText, fontSize: "16px", mb: 2
  
              }
            }
             />}
             <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        mt: 2,
        gap: 2,
      }}
    >
      <IconButton
        onClick={() => handleQuantityChange(item, false)}
        disabled={(quantities[item.idproduct] || 1) === 1}
        sx={{
          color: selectedExtraProduct?.some(
            (product) => product.idproduct === item.idproduct
          )
            ? theme?.product?.addBtnTextActive
            : theme?.product?.addBtnTextColor,
          "&:hover": {
            color: theme?.product?.addBtnTextHover,
          },
        }}
      >
        <RemoveCircle fontSize="large" />
      </IconButton>
  
      <Typography
        sx={{
          fontSize: "16px",
          fontWeight: "bold",
          color: selectedExtraProduct?.some(
            (product) => product.idproduct === item.idproduct
          )
            ? "#fff"
            : theme?.product?.addMinTextColor,
        }}
      >
        {quantities[item.idproduct] || 1}
      </Typography>
  
      <IconButton
        onClick={() => handleQuantityChange(item, true)}
        sx={{
          color: selectedExtraProduct?.some(
            (product) => product.idproduct === item.idproduct
          )
            ? theme?.product?.addBtnTextActive
            : theme?.product?.addBtnTextColor,
          "&:hover": {
            color: theme?.product?.addBtnTextHover,
          },
        }}
      >
        <AddCircle fontSize="large" />
      </IconButton>
  
      <IconButton
        onClick={() => handleProductSelect(item)}
        sx={{
          backgroundColor: selectedExtraProduct?.some(
            (product) => product.idproduct === item.idproduct
          )
            ? theme?.product?.addBtnActive
            : theme?.product?.addBtnBg,
          borderRadius: "50%",
          width: "50px",
          height: "50px",
          transition: "all 0.3s ease",
          "&:hover": {
            backgroundColor: theme?.product?.addBtnBgHover,
            transform: "scale(1.1)",
          },
        }}
      >
        {selectedExtraProduct?.some(
          (product) => product.idproduct === item.idproduct
        ) ? (
          <RemoveCircle fontSize="large" sx={{ color: "#fff" }} />
        ) : (
          <AddCircle fontSize="large" sx={{ color: "#fff" }} />
        )}
      </IconButton>
    </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  ))}
  
  {extraProductData?.data?.length > 4 && (
     <Box
     sx={{
       display: "flex",
       justifyContent: "center",
       alignItems: "center",
     }}
   >
     <IconButton
              sx={{
               backgroundColor: theme?.product?.addBtnBg,
               fontSize: "14px",
               color: theme?.product?.addBtnTextColor,
               
               "&:hover": {
                 backgroundColor: theme?.product?.addBtnBgHover,
                 color: theme?.product?.addBtnTextHover,
               },
             }}
             onClick={() => setIsShowMore(!isShowMore)}
     >
       {
         !isShowMore ? <ExpandMoreTwoToneIcon /> : <ExpandLessTwoToneIcon />
       }
     </IconButton>
  
   </Box>
  )}
  </Grid2>
  
        <Grid2 size={{ md: 3, sm: 12, xs: 12 }}>
           <CardSection 
            totalCount={totalCount}
            languageWords={languageWords}
            reservType={reservType}
            selectedDate={selectedDate}
            adult={adult}
            child={child}
            kid={kid}
            baby={baby}
            toddler={toddler}
            selectedExtraProduct={selectedExtraProduct}
            time={time}
            transactionDetails={transactionDetails}
            selectedCombination={selectedCombination}
            transactionPrice={transactionPrice}
            excludingVat={excludingVat}
            totalVat={totalVat}
            totalIncludingVAT={totalIncludingVAT}
            totalCostYourBooking={totalCostYourBooking}
           />
        </Grid2>
      </Grid2>
    </Box>
    );
  };
  
  export default UpsaleProduct;
  